import { useHistory } from 'react-router-dom';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { SearchHitHighlightOrDocumentValue } from 'components/search/SearchHitHighlightOrDocumentValue';
import { SearchResultContactLabel } from 'components/search/SearchResultContactLabel';
import * as SearchResults from 'components/search/SearchResults';
import { useSearchStore } from 'components/search/useSearchStore';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const SearchContactsResults = () => {
    const { accountId } = useCurrentAccount();
    const { setIsOpen } = useSearchStore();
    const history = useHistory();
    const { isEmpty, getKey, data } = SearchResults.useSearchResultsProps('contacts');

    if (isEmpty) {
        return null;
    }

    return (
        <SearchResults.Root>
            <SearchResults.Title>Contacts</SearchResults.Title>
            {data.hits.map(hit => {
                return (
                    <SearchResults.ListItem
                        key={getKey(hit.document.id)}
                        onClick={() => {
                            history.push(`/accounts/${accountId}/contacts/${hit.document.id}`);
                            setIsOpen(false);
                        }}
                    >
                        <SearchResults.Icon icon={faUser} />
                        <SearchResultContactLabel hit={hit} resource="contact" />
                        <SearchHitHighlightOrDocumentValue
                            hit={hit}
                            documentKey={'primary_email'}
                            className={'text-gray-500'}
                        />
                    </SearchResults.ListItem>
                );
            })}
        </SearchResults.Root>
    );
};

export { SearchContactsResults };
